module.exports = __webpack_public_path__ + "img/20170704_135648_094.c9e84c98.jpg";